/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export enum CallClosedReason {
  FRAUD = 'FRAUD',
  NO_SHOW = 'NO_SHOW',
  TECHNICAL_ISSUES = 'TECHNICAL_ISSUES',
  INCORRECT_DOCUMENT = 'INCORRECT_DOCUMENT',
  UNABLE_TO_VALIDATE_SIGNER_IDENTITY = 'UNABLE_TO_VALIDATE_SIGNER_IDENTITY',
  RESCHEDULED = 'RESCHEDULED',
  OTHER = 'OTHER',
}

export enum CallClosedReasonV1 {
  NO_SHOW = 'NO_SHOW',
  UNABLE_TO_PASS_IDV = 'UNABLE_TO_PASS_IDV',
  UNABLE_TO_PASS_KBA = 'UNABLE_TO_PASS_KBA',
  DEVICE_SETUP_ISSUE = 'DEVICE_SETUP_ISSUE',
  UNABLE_TO_SIGN = 'UNABLE_TO_SIGN',
  AUDIO_VIDEO_ISSUE = 'AUDIO_VIDEO_ISSUE',
  MISSING_CRITICAL_DOCUMENTS = 'MISSING_CRITICAL_DOCUMENTS',
  DECLINE_TO_SIGN = 'DECLINE_TO_SIGN',
  FRAUD = 'FRAUD',
  OTHER = 'OTHER',
}

// note: DO NOT SORT, affects ordering in dropdown list
export const CallClosedReasonLabels: { [key in CallClosedReason]: string } = {
  [CallClosedReason.NO_SHOW]: 'Signer(s) did not show up',
  [CallClosedReason.UNABLE_TO_VALIDATE_SIGNER_IDENTITY]: 'Signer(s) unable to validate identity',
  [CallClosedReason.RESCHEDULED]: 'Rescheduled',
  [CallClosedReason.TECHNICAL_ISSUES]: 'Experiencing technical issues',
  [CallClosedReason.INCORRECT_DOCUMENT]: 'The wrong documents were in the room',
  [CallClosedReason.FRAUD]: 'Suspicion of fraud',
  [CallClosedReason.OTHER]: 'Other reason',
};

export const CallClosedReasonLabelsV1: { [key in CallClosedReasonV1]: string } = {
  [CallClosedReasonV1.NO_SHOW]: 'Signer(s) did not show up',
  [CallClosedReasonV1.UNABLE_TO_PASS_IDV]: 'Signer(s) unable to validate their Drivers License/Passport',
  [CallClosedReasonV1.UNABLE_TO_PASS_KBA]: 'Signer(s) unable to pass KBA',
  [CallClosedReasonV1.DEVICE_SETUP_ISSUE]: 'Signer(s) unable to move beyond device setup',
  [CallClosedReasonV1.UNABLE_TO_SIGN]: 'Signer(s) unable to sign documents in the signing room',
  [CallClosedReasonV1.AUDIO_VIDEO_ISSUE]: 'Audio/Video issues in the signing room',
  [CallClosedReasonV1.MISSING_CRITICAL_DOCUMENTS]: 'Missing critical documents',
  [CallClosedReasonV1.DECLINE_TO_SIGN]: 'Signer(s) declines to sign documents',
  [CallClosedReasonV1.FRAUD]: 'Suspicion of fraud',
  [CallClosedReasonV1.OTHER]: 'Other reason',
};
